import { render, staticRenderFns } from "./activity-collectCards-compose.vue?vue&type=template&id=90e59ef6&scoped=true&"
import script from "./activity-collectCards-compose.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards-compose.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards-compose.vue?vue&type=style&index=0&id=90e59ef6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e59ef6",
  null
  
)

export default component.exports